// Read-only presentation helpers. API finance totals remain authoritative.
const text = (value) => typeof value === 'string' || typeof value === 'number' ? String(value) : '';
const nonnegative = (value) => typeof value === 'number' && Number.isFinite(value) && value >= 0;
export const pickOrderValue = (row, ...keys) => {
  for (const key of keys) if (row?.[key] !== undefined && row[key] !== null && row[key] !== '') return row[key];
  return '';
};
export function orderStatus(value) {
  const status = String(value || '').trim().toUpperCase();
  if (status.startsWith('SOLD')) return 'SOLD';
  if (status.startsWith('CANCEL') || status === 'BATAL') return 'CANCEL';
  return status || 'ORDER';
}
function numeric(value) {
  if (typeof value === 'number') return value;
  return typeof value === 'string' && /^\d+(?:\.\d+)?$/.test(value) ? Number(value) : NaN;
}
export function groupOrderItems(orders) {
  const result = [], groups = new Map();
  (Array.isArray(orders) ? orders : []).forEach((source, index) => {
    if (!source || typeof source !== 'object') return;
    const product = text(pickOrderValue(source, 'product_id', 'Product_ID'));
    const price = numeric(pickOrderValue(source, 'price', 'harga'));
    const quantity = numeric(pickOrderValue(source, 'qty', 'quantity', 'jumlah'));
    const valid = source.grouping_allowed === true && source.quantity_valid !== false && source.unit_price_valid !== false && product && Number.isSafeInteger(price) && price >= 0 && Number.isSafeInteger(quantity) && quantity > 0 && Number.isSafeInteger(price * quantity);
    // Product ID is required. Equal-looking unknown products must remain separate.
    // Exact raw status and variant fields prevent broad display normalization from merging rows.
    const key = valid ? JSON.stringify([
      text(pickOrderValue(source, 'customer_id', 'Customer_ID')),
      text(pickOrderValue(source, 'po_id', 'PO_ID')), product,
      text(pickOrderValue(source, 'item', 'name', 'nama', 'product', 'barang')),
      text(pickOrderValue(source, 'variant', 'varian', 'Variant')),
      text(pickOrderValue(source, 'color', 'warna', 'Warna')),
      text(pickOrderValue(source, 'size', 'ukuran', 'Size')), price,
      Object.prototype.hasOwnProperty.call(source, 'raw_status') ? text(source.raw_status) : text(pickOrderValue(source, 'status', 'Status_Barang')),
    ]) : null;
    const prior = key === null ? null : groups.get(key);
    if (prior && Number.isSafeInteger(prior._quantity + quantity) && Number.isSafeInteger(prior._subtotal + price * quantity)) {
      prior._quantity += quantity;
      prior._subtotal += price * quantity;
      prior._sourceCount += 1;
      return;
    }
    const row = { ...source, _i: index, _status: orderStatus(pickOrderValue(source, 'status', 'Status_Barang')),
      _quantity: source.quantity_valid !== false && Number.isSafeInteger(quantity) && quantity >= 0 ? quantity : null,
      _subtotal: source.quantity_valid !== false && source.unit_price_valid !== false && Number.isSafeInteger(price) && price >= 0 && Number.isSafeInteger(quantity) && quantity >= 0 && Number.isSafeInteger(price * quantity) ? price * quantity : null,
      _sourceCount: 1 };
    result.push(row);
    if (key !== null) groups.set(key, row);
  });
  return result;
}
export function paymentMethod(value) {
  const methods = { BCA: 'BCA', BANK_LAIN: 'Bank lain', 'E-WALLET': 'E-wallet', LAINNYA: 'Lainnya' };
  return Object.prototype.hasOwnProperty.call(methods, value) ? methods[value] : 'Metode belum tercatat';
}
export function formatWeightKg(value) {
  return nonnegative(value) && value > 0 ? `${new Intl.NumberFormat('id-ID', { maximumFractionDigits: 3 }).format(value)} kg` : 'Berat belum tersedia';
}
export function shippingFeeLabel(state, amount, formatMoney) {
  if ((state === 'free' || state === 'fully_subsidized') && amount === 0) return 'Gratis ongkir';
  if (state === 'charged' && nonnegative(amount) && amount > 0) return formatMoney(amount);
  return 'Menunggu ongkir';
}
